<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside width="100" type="light" />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
        <h3 class="mt-5">{{$t('message.Jobs')}}</h3>
        <br>
        <b-card class="card" style="margin: 0 auto">
          <header class="header">
            <h2
            >{{$t('message.Position_information')}}
            </h2>
          </header>
          <b-row v-if="all_applications">
            <b-col
                md="6"
                style="font-size: 15px;
                padding-top: 60px">
              <p
              ><span class="font-weight-semibold">
                {{$t('message.Work_place')}}
              </span>:
                <span
                    class="text"> {{all_applications.region.nameuz}}<br>
            {{all_applications.rayon.nameru}} {{all_applications.school.organizationfullname}}</span></p>
              <br>
              <p><span class="font-weight-semibold">{{$t('message.Rank')}}</span>:
                <span class="text">{{all_applications.position_level.name}}</span></p>
              <br>
              <p>
                <span class="font-weight-semibold">
                {{$t('message.Salary')}}
              </span>:<span class="text">{{all_applications.salary}}</span></p>
              <br>
              <p><span class="font-weight-semibold">
                {{$t('message.Work_experience')}}
              </span>:
                <span class="text">{{all_applications.work_experience.name}}</span></p>
              <br>
              <p><span class="font-weight-semibold">
                {{$t('message.Job_number')}}
              </span>:
                <span
                    class="text">{{all_applications.vacancy_count}}</span></p>
              <br>
              <p><span class="font-weight-semibold">
                {{$t('message.Educational_information')}}
              </span>:
                <span class="text">{{all_applications.education ? all_applications.education.name : ''}}</span></p>
            </b-col>
            <b-col
                md="6"
                style="font-size: 15px;
                padding-top: 60px">
              <p><span class="font-weight-semibold">
                {{$t('message.Work_type')}}
              </span>:
                <span
                    class="text">{{all_applications.job_type.name}}</span></p>
              <br>
              <p><span class="font-weight-semibold">
                {{$t('message.Form_payment')}}
              </span>:
              <span class="text">{{all_applications.payment_type.name}}</span></p>
              <br>
              <p><span class="font-weight-semibold">
                {{$t('message.Workplace_employment')}}
              </span>:
                <span
                    class="text">{{all_applications.workplace_employment ? all_applications.workplace_employment.name : ''}}</span></p>
              <br>
              <p><span class="font-weight-semibold">
                {{$t('message.Phone_number')}}
              </span>:
                <span
                    class="text">{{all_applications.contact_number}}</span></p>
              <br>
              <p><span class="font-weight-semibold">
                {{$t('message.Add_posted')}}
              </span>:
                <span
                    class="text">{{all_applications.created_at | formatDate}}</span></p>
              <br>
              <p><span class="font-weight-semibold">
                {{$t('message.Submission_deadline')}}
              </span>:
                <span
                    class="text">{{all_applications.deadline | formatDate}}</span></p>
            </b-col>
          </b-row>
        </b-card>
          <b-card class="mt-4 mb-4" style="margin: 0 auto;">
            <div class="w-100 d-flex justify-content-end mb-2">
              <b-button @click="challangeClick()" variant="primary">
                {{$t('message.Challenge')}}
              </b-button>
              <b-button variant="warning" @click="activateTest()" class="ms-2"
                        v-if="applications.every(item => item.cur_status.id !== 1) && applications.every(item => item.test_allowed === false)">
                {{$t('message.Activate_test')}}
              </b-button>
            </div>
            <b-table
                responsive
                striped
                hover
                :items="applications"
                :fields="fields">
              <template #cell(allow)="data">
                <div v-if="data.item.cur_status_id === 1">
                  <span v-if="data.item.test_status">{{data.item.test_status.call_date}} {{data.item.test_status.call_time}}</span>
                  <b-button variant="outline-primary"
                            v-if="!data.item.test_status" size="sm"
                            @click="denyTestApplication(data.item.id)">{{$t('message.Deny_application')}}</b-button>
                  <span v-if="data.item.cur_status">
                  {{data.item.cur_status.name_ru}}
                </span>
                </div>
                <div v-else>
                  {{data.item.cur_status.name}}
                </div>
              </template>
              <template #cell(activateTest)="data">
                <div v-if="data.item.cur_status.id === 2">
<!--                  <b-button v-if="data.item.test_allowed === false && data.item.cur_status.status_name !== 'rejected'"-->
<!--                            variant="warning" @click="activateTest(data.item.id, true)">-->
<!--                    {{$t('message.Activate_test')}}-->
<!--                  </b-button>-->
                  <span v-if="data.item.test_allowed === true" class="text-primary">
                  {{$t('message.Allowed')}}
                </span>
                </div>
                <b-button
                    style="background-color: #185d89"
                    size="md" @click="showAppModal(data.item)">
                  <i class="bx bx-show"></i>
                </b-button>
                <b-button v-if="data.item.cur_status.id !== 3" class="ms-2" variant="outline-warning" @click="denyTestApplication(data.item.id, false);">{{$t('message.Deny')}}</b-button>
              </template>
            </b-table>
            <div class="d-flex justify-content-end mt-3">
              <b-pagination
                  v-model="pagination.page"
                  hide-goto-end-buttons
                  :total-rows="total"
                  :per-page="pagination.pageSize"
                  @page-click="fetchJobApplications()"
              />
            </div>
            <div class="d-flex">
            <b-modal id="modal-center" centered hide-footer size="lg" v-model="challangeModal">
              <Form :testStatus="testStatus" :app="all_applications" @closeForm="closeForm" />
            </b-modal>
            <b-modal id="modal-1" hide-footer size="md" v-model="denyModal">
              <DenyApplication :testStatus="testStatus" :app="all_applications" @closeDenyForm="closeDenyForm" />
            </b-modal>
              <b-modal id="modal-2" hide-footer size="md">
                <DenyTest />
              </b-modal>
            </div>
          </b-card>
<!--        <div class="button">-->
<!--          <b-button variant="primary">{{$t('message.Cancel')}}</b-button>-->
<!--          <b-button style="margin-left: 15px" variant="warning">{{$t('message.Call_all')}}</b-button>-->
<!--        </div>-->

        <b-modal v-model="applicationModal" hide-footer size="lg">
          <b-row v-if="activeApplication">
            <b-col md="6">
              <div class="w-100 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.FullName')}}</h5>
                <p>{{activeApplication.fio}}</p>
              </div>
              <div class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.Category')}}</h5>
                <p>{{activeApplication.category ? activeApplication.category.name : ''}}</p>
              </div>
              <div v-if="!!activeApplication.education" class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.Education')}}</h5>
                <p>{{activeApplication.education.name}}</p>
              </div>
              <div class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.Experience')}}</h5>
                <p>{{activeApplication.experience ? activeApplication.experience.name : ''}}</p>
              </div>
              <div class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.Work_experience')}}</h5>
                <p v-for="(exp, expIndex) in activeApplication.working_experiences" :key="expIndex">
                  {{exp.experience.name}} - {{exp.year}}</p>
              </div>
              <div class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.Mobile_number')}}</h5>
                <p>{{activeApplication.mobile}}</p>
              </div>
              <div class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.Address')}}</h5>
                <p>{{activeApplication.address}}</p>
              </div>
            </b-col>
            <b-col md="6">
              <div class="w-100 border-bottom">
                <h5>{{$t('message.LanguageLevel')}}</h5>
                <div v-if="activeApplication.language_levels">
                  <div class="w-100 my-1" v-for="(lang, langIndex) in activeApplication.language_levels" :key="langIndex">
                    {{lang.language.name}} - {{lang.level.name}}
                  </div>
                </div>
              </div>
              <div v-if="activeApplication.objective !== 'null'" class="w-100 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.Objective')}}</h5>
                <a :href="$backendHost+activeApplication.objective" target="_blank" class="btn btn-outline-warning">
                  <i class="bx bx-download"></i>
                </a>
              </div>
              <div class="w-100 border-bottom" v-if="activeApplication.government_reward !== 'null'">
                <h5 class="font-weight-semibold">{{$t('message.Government_reward')}}</h5>
                <a :href="$backendHost+activeApplication.government_reward" target="_blank" class="btn btn-outline-warning">
                  <i class="bx bx-download"></i>
                </a>
              </div>
              <div class="w-100 border-bottom" v-if="activeApplication.other_reward !== 'null'">
                <h5 class="font-weight-semibold">{{$t('message.Other_reward')}}</h5>
                <a :href="$backendHost+activeApplication.other_reward" target="_blank" class="btn btn-outline-warning">
                  <i class="bx bx-download"></i>
                </a>
              </div>
              <div class="w-100 border-bottom" v-if="activeApplication.workable_document !== 'null'">
                <h5 class="font-weight-semibold">{{$t('message.Entitling')}}</h5>
                <a :href="$backendHost+activeApplication.workable_document" target="_blank" class="btn btn-outline-warning">
                  <i class="bx bx-download"></i>
                </a>
              </div>
              <div class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.PINFL')}}</h5>
                <p>{{activeApplication.pinfl}}</p>
              </div>
            </b-col>
          </b-row>
        </b-modal>

      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../../../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import Form from "../call-candidates/Form";
import DenyApplication from "../denying/DenyApplication";
import DenyTest from "../denying/DenyTest";
import {getSchoolVacancyApplications, haveAccessToTest} from "../../../../../../../api/school-vacany-applications";
import Swal from "sweetalert2";
import {applicationAllJobs} from "../../../../../../../api/school_job_vacancy";
import moment from 'moment'
import HorizontalTopbarInside from "../../../../../../../components/horizontal-topbar-inside";


export default {
  name: "job-information",
  components: {
    HorizontalTopbarInside,
    DenyTest,
    DenyApplication,
    Form, SideBar
  },
  data() {
    return {
      isMenuCondensed: false,
      selected: null,
      challangeModal: false,
      denyModal: false,
      applicationModal: false,
      activeApplication: null,
      options: [
        { value: null, text: 'Please select an option' },
        { value: 'a', text: 'This is First option' },
        { value: 'b', text: 'Selected Option' },
        { value: 'c', text: 'This is an option with object value' },
      ],
      fields: [
        {
          label: '№',
          key: 'no'
        },
        {
          label: this.$t('message.FullName'),
          key: "fio"
        },
        {
          label: this.$t('message.Mobile_number'),
          key: "mobile"
        },
        {
          label: this.$t('message.Call_or_reject'),
          key: "allow"
        },
        {
          label: this.$t('message.Activate_test'),
          key: "activateTest"
        }
        ],
      applications: [],
      all_applications:null,
      total: 1,
      pagination: {
        page: 1,
        pageSize: 15,
        vacancy_id: this.$route.params.id
      },
      testStatus: {
        status: null,
        application_id: null,
      }
    };
  },
  filters:{
    formatDate(val) {
      return moment(val).format('DD-MM-YYYY')
    }
  },
  computed: {
    ...layoutComputed,
  },
  created()  {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
    this.fetchJobApplications()
    this.fetchAllApplications()

  },
  methods: {
    fetchAllApplications(){
      applicationAllJobs(this.$route.params.id).then(response => {
        this.all_applications = response.data.data
      })
    },
    fetchJobApplications() {
      getSchoolVacancyApplications(this.pagination).then(res => {
        this.applications = res.data.data.data.map((val, index) =>
        Object.assign({}, val,{id: val.id, no: index+1, fio:val.last_name+" "+val.first_name+" "+val.middle_name,
          mobile: val.mobile,test_status: val.test_status, test_allowed:val.test_allowed,cur_status: val.cur_status}));
        this.total = res.data.data.total
        // eslint-disable-next-line no-console
      })
    },
    challangeClick() {
      if(moment().isBefore(moment(this.all_applications.deadline))) {
         this.$vs.notification({
          position: 'top-right',
          color: "warning",
          title: '',
          text: this.$t('challengeDeadlineIsNotYet')
        })
      }
      else {
        this.testStatus.application_id = this.all_applications.id;
        this.testStatus.status = 2;
        this.challangeModal = true;
      }
    },
    denyTestApplication(id) {
      this.testStatus.application_id = id;
      this.testStatus.status = 3;
      this.denyModal = true;
    },
    closeForm() {
      this.challangeModal = false;
      this.fetchJobApplications()
      this.fetchAllApplications()
    },
    closeDenyForm() {
      this.denyModal = false;
      this.fetchJobApplications()
    },
    showAppModal(item) {
      this.applicationModal= true;
      this.activeApplication = item;
      // eslint-disable-next-line no-console
      console.log(item)
    },
    activateTest() {
      Swal.fire({
        title: this.$t('message.DoYouWantAllowTest'),
        text: this.$t('message.Not_Test_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t("message.Allow"),
        cancelButtonText: this.$t('message.Cancel'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          // eslint-disable-next-line no-unused-vars
          haveAccessToTest({ vacancy_id: this.all_applications.id, status:true}).then(res => {
            Swal.fire({
              icon: 'success',
              position: 'center',
              title: this.$t('message.HasAllowed'),
              text: this.$t('message.TestAllowed'),
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.fetchJobApplications()
          })
        } else if (result.dismiss === 'cancel') {
          Swal.fire({
            title: this.$t('message.Cancelled'),
            text: this.$t('message.NotAllowed'),
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
}
</script>

<style scoped>

h2 {
  text-align: center;
  color: #ffffff;
}
h3 {
  margin-left: 70px;
  font-size: 28px;
  color: #185d89;
}
.header{
  background-color: #185d89;
  padding-top: 30px;
  padding-bottom: 30px;
  border-radius: 15px
}
.card{
  margin-left: 80px;
  width: 85%;
}
.button{
  margin-left: 500px;
}
</style>



